import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { queryKeys } from "../constants";
import {
  getExpenseCategories,
  getExpenseCategoryById,
  deleteExpenseCategory,
  createExpenseCategory,
  updateExpenseCategory,
} from "services/expenseCategory.service";
import { queryClient } from "utils";
import { expenseCategoryType } from "types/expenseCategory";

// Fetch all expense-categories
export const useGetExpenseCategories = () => {
  return useQuery({
    queryKey: [queryKeys.expenseCategories],
    queryFn: async () => await getExpenseCategories(),
  });
};

// Fetch a single expense-category by ID
export const useGetExpenseCategoryById = (id) => {
  return useQuery({
    queryKey: [queryKeys.expenseCategories, id],
    queryFn: async () => await getExpenseCategoryById(id),
    enabled: !!id, // Only run query if ID is provided
  });
};

// Create a new expense-category
export const useCreateExpenseCategory = () => {
  return useMutation({
    mutationFn: createExpenseCategory,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.expenseCategories],
      });
    },
  });
};

type UpdateExpenseCategoryPayload = {
  id: string;
  data: expenseCategoryType;
};

// Update the useUpdateExpenseCategory hook
export const useUpdateExpenseCategory = (): UseMutationResult<
  any,
  Error,
  UpdateExpenseCategoryPayload
> => {
  return useMutation<any, Error, UpdateExpenseCategoryPayload>({
    mutationFn: ({ id, data }: UpdateExpenseCategoryPayload) =>
      updateExpenseCategory(id, data),
    onSuccess: async () => {
      // Invalidate expense-categories query on success
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.expenseCategories],
      });
    },
  });
};

// Delete an expense-category
export const useDeleteExpenseCategory = () => {
  return useMutation({
    mutationFn: deleteExpenseCategory,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.expenseCategories],
      });
    },
  });
};
